import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import * as _ from 'lodash';
import { environment } from '../../shared/config/app-config';
import { Puser, User, UserService } from '../../shared';

@Component({
  templateUrl: 'appointment.component.html',
  styleUrls: ['./style.component.css']
})

export class AppointmentComponent implements OnInit {
  PUser: Puser;
  CurrentUser: User;
  resp: any;
  public data: Object;
  apiurl: any = environment.api_url;
  public imageURL: string;
  public appointment: any;

  constructor(
    private route: ActivatedRoute,
    public datepipe: DatePipe,
    private userService: UserService
  ) { }

  ngOnInit() {
    this.userService.currentUser.subscribe(
      (userData) => {
        this.CurrentUser = userData;
      }
    )
    if (this.CurrentUser.item.hostModel == "CLOUD")
      this.imageURL = environment.cloudeImageURL;
    else
      this.imageURL = environment.vmImageURL

    if (this.route.snapshot.url[0].path != 'assessment') {
      this.CurrentUser.operationStatus = ''
    }
    this.userService.PUser.subscribe(
      (puserData) => {
        this.resp = puserData;
      }
    )
    this.userService.getappointment(window.localStorage['Puser']).subscribe(
      data => {
        let index = data.findIndex(x => x.DefaultTitle == "Discharge");
        if (index !== -1) {
          data.splice(index, 1);
        }
        this.appointment = _.orderBy(data, ['Iscompleted'], ['desc']);
        this.appointment = this.appointment.filter(obj => {
          return obj.AppointmentDate != ' '
        })
      }
    );
  }

}
